module.exports = __webpack_public_path__ + "components/profile/static/icon-caret-right-468a18892bbec4e3df2c3722ab129005.svg";